import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   *
   * @author Ju
   * @return {Array} 활성화된 관리 구분 목록
   */

  /**
   * 파라미터로 전달한 관리 구분에 해당하는 화면에 표시할 관리 구분 키를 조회한다.
   * @author Ju
   * @param  {String} managetypeId 관리 구분 아이디
   * @return  {Array} 관리 구분에 해당하는 화면에 표시할 관리 구분 키 목록
   */
  getDisplayedManagetypeKeyList(managetypeId) {
    return axios.get(`${baseUrl}/common/obj-type/get-displayed-managetype-key-list.do`, {
      params: {
        managetypeId,
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/model/managetype-key.js